import { render, staticRenderFns } from "./bulkShipment.vue?vue&type=template&id=4423f47f&scoped=true&"
import script from "./bulkShipment.vue?vue&type=script&lang=js&"
export * from "./bulkShipment.vue?vue&type=script&lang=js&"
import style0 from "./bulkShipment.vue?vue&type=style&index=0&id=4423f47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423f47f",
  null
  
)

component.options.__file = "bulkShipment.vue"
export default component.exports